/*
 *  I15TAUXCOUVBOISI18n.ts
 *
 *  Created by Sébastien Hecart on 2022-06-27 10:29:55 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

export default {
  I15TAUXCOUVBOIS_SECTION_0_TITLE: 'Calculez le taux de couverture des besoins en fonction du pourcentage de couverture des déperditions',
  I15TAUXCOUVBOIS_in_puissance_biomasse: 'Puissance de la biomasse',
  I15TAUXCOUVBOIS_in_puissance_total: 'Puissance totale installée',
  I15TAUXCOUVBOIS_res_couverture_biomasse: 'Taux de couverture de la biomasse'
}
